module.exports = __webpack_public_path__ + "fc7c2d28f447a31bd1f3c806937c3905.png";